// Activity on the On Ground tab: which aircraft are doing something (moving, or heard from in the
// last minute) and which are sitting at a stand. Drives the table's sort, its Active / Parked group
// dividers and the map marker colour, so all three agree.

// Aircraft is "active" on the apron if it's doing anything other than
// sitting at a stand. Drives whether the marker is rendered normally
// (yellow per the live-map convention) or in ghost mode (greyed-out at
// 50% opacity, mirroring the Departures map's treatment of arrived
// aircraft).
export function isActiveOnGround(state) {
    if (!state) return false;
    const s = state.toLowerCase();
    return s.includes('taxi') || s.includes('pushback') || s.includes('engines') || s.includes('hold');
}

// "Recently active" = we received a surface ADS-B message from this
// aircraft within the last RECENT_ACTIVE_MS. One minute, the same
// timeout the live map uses to drop a target: once the map has let an
// aircraft go, the table must not keep it "taxiing" (user report
// 2026-09-19 — Taxiing In rows 29 min on the ground with nothing on the
// map). The backend applies the same 60 s in its ground-state CASE.
// Using the last-update time (ags.last_surface_at on the backend) as
// the proxy for "we're still hearing it". Wins over the state field.
export const RECENT_ACTIVE_MS = 60 * 1000;
export function isRecentlyActive(lastUpdateAt, nowMs) {
    if (!lastUpdateAt) return false;
    const t = Date.parse(lastUpdateAt);
    if (Number.isNaN(t)) return false;
    return (nowMs - t) <= RECENT_ACTIVE_MS;
}

/** Active = heard from in the last minute, or in a moving state (taxi, pushback, engines, hold). */
export function isOnGroundActive(a, nowMs) {
    return isRecentlyActive(a?.lastUpdateAt, nowMs) || isActiveOnGround(a?.groundState);
}

/**
 * Splits the On Ground table's rows into its two divider groups, keeping the incoming sort within
 * each: Active first, then Parked (everything else).
 */
export function groupOnGroundRows(rows, nowMs) {
    const active = [];
    const parked = [];
    for (const a of rows) (isOnGroundActive(a, nowMs) ? active : parked).push(a);
    return { active, parked };
}
